import { Components, Theme, ThemeOptions } from '@mui/material/styles';

const getModalTheme = (theme: Theme): ThemeOptions => {
  const modalTheme: Components<Theme>['MuiModal'] = {
    defaultProps: {
      slotProps: {
        backdrop: {
          sx: {
            backgroundColor:
              theme.palette.M3['state-layers'].light['on-surface'][
                'opacity-0.12'
              ],
          },
        },
      },
    },
    styleOverrides: {
      root: {
        '& .modal-container': {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: theme.palette.M3.sys.light.surface,
          boxShadow: theme.shadows[4],
          padding: theme.unit(6, 8),
          borderRadius: theme.unit(4),
          maxHeight: '90vh',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        },
        '& .modal-content': {
          overflow: 'auto',
          flexGrow: 1,
        },
      },
    },
  };

  const backdropTheme: Components<Theme>['MuiBackdrop'] = {
    styleOverrides: {
      root: {
        backgroundColor:
          theme.palette.M3['state-layers'].light['on-surface']['opacity-0.12'],
      },
    },
  };

  return {
    components: {
      MuiModal: modalTheme,
      MuiBackdrop: backdropTheme,
    },
  };
};

export default getModalTheme;
